// Shared blog posts data for both client and server
export const blogPosts = [
  {
    id: "seniors-propietaris-economia",
    slug: "mes-de-65-felicitats-teniu-leconomia",
    title: "Més de 65 anys? Felicitats: teniu l'economia",
    category: "Economia / Política",
    date: "19 feb 2026",
    excerpt: "Els majors de 70 anys controlen el 39% de les accions i el 32% de la riquesa neta dels EUA. Mai havia estat millor moment per ser gran, però els recursos continuen fluint cap als ancians mentre els joves s'ofeguen.",
    description: "Els majors de 70 anys controlen el 39% de les accions i el 32% de la riquesa neta als EUA. Mai havia estat millor moment per ser gran, però els recursos segueixen fluint cap als ancians mentre les generacions joves s'enfronten a preus d'habitatge desorbitants, deute i la incertesa de la IA.",
    image: "/seniors-economia.jpg",
    imageAlt: "Persones grans i economia als EUA",
  },
  {
    id: "ia-programari-creixement",
    slug: "la-ia-no-matara-el-negoci-del-programari",
    title: "La IA no matarà el negoci del programari, només la seva història de creixement",
    category: "Tech / IA",
    date: "4 feb 2026",
    excerpt: "Les pors que les empreses de programari s'enfrontin a un esdeveniment d'extinció són exagerades, però altres perills són ben reals.",
    description: "Les accions de programari han caigut un 30% des de setembre. L'anunci d'Anthropic sobre Claude Cowork ha intensificat les pors, però la creença que la IA substituirà plataformes complexes és exagerada.",
    image: "/software-ia.jpg",
    imageAlt: "Intel·ligència artificial i programari"
  },
  {
    id: "google-alphabet-ia",
    slug: "google-aposta-fort-pel-seu-lideratge-en-ia",
    title: "Google aposta fort pel seu lideratge en IA",
    category: "Tech / IA",
    date: "5 feb 2026",
    excerpt: "El creixement accelerat en publicitat i núvol justifica la pujada recent de les accions d'Alphabet, però la inversió anunciada en infraestructura encara deixa tothom bocabadat.",
    description: "Google anuncia plans per invertir fins a 185.000 milions de dòlars en IA aquest any, pràcticament el doble del desemborsament de l'any passat. El model Gemini 3 ha posicionat Google al capdamant del rendiment.",
    image: "/google-ai.jpg",
    imageAlt: "Sundar Pichai, CEO de Google"
  },
  {
    id: "warsh-fed",
    slug: "dir-que-vols-reduir-la-fed",
    title: "Dir que vols reduir la Fed és una cosa. Fer-ho és una altra.",
    category: "Fed / Política Monetària",
    date: "2 feb 2026",
    excerpt: "La visió de 'canvi de règim' de Kevin Warsh al banc central podria significar temps més difícils per als mercats.",
    description: "Kevin Warsh, candidat a presidir la Reserva Federal, proposa un 'canvi de règim' al banc central. Els mercats haurien de preparar-se per temps més difícils si les seves idees es fan realitat.",
    image: "/kevin-warsh.jpg",
    imageAlt: "Kevin Warsh"
  },
  {
    id: "oracle-openai",
    slug: "que-arrisca-oracle-amb-openai-nvidia",
    title: "Què arrisca Oracle amb la relació entre OpenAI i Nvidia",
    category: "Tech / Cloud",
    date: "2 feb 2026",
    excerpt: "El gir de Nvidia amb OpenAI posa la comptabilitat d'Oracle sota els focus. I les xifres no pinten gaire bé.",
    description: "La nova aliança entre OpenAI i Nvidia posa en dubte els ingressos restants de rendiment (RPO) d'Oracle. La comptabilitat d'Oracle està sota escrutini després de l'anunci de Stargate.",
    image: "/oracle-sign.jpg",
    imageAlt: "Oracle Corporation"
  },
  {
    id: "panic-mercats-privats-ia",
    slug: "panic-ia-mercats-privats",
    title: "El pànic de la IA als mercats privats: quan els \"ingressos recurrents\" deixen de ser-ho",
    category: "Mercats / IA",
    date: "8 feb 2026",
    excerpt: "Els inversors comencen a desconfiar del capital privat i dels préstecs construïts sobre resultats suposadament previsibles.",
    description: "La por que la IA capgiri el sector del programari ha encès totes les alarmes entre els inversors de gestores d'actius privats. Les firmes de crèdit privat, amb un 22% del deute vinculat a empreses de programari, s'enfronten a una crisi de confiança.",
    image: "/private-markets-panic.jpg",
    imageAlt: "Mercats privats i IA"
  },
  {
    id: "picks-shovels-ia",
    slug: "picks-and-shovels-la-febre-de-lor-de-la-ia",
    title: "Picks & Shovels: qui guanya de veritat amb la febre de l'or de la IA",
    category: "Tech / Inversió",
    date: "13 feb 2026",
    excerpt: "A la febre de l'or, els que es van fer rics van ser els que venien pics i pales. A la revolució de la IA, els guanyadors són els que construeixen la infraestructura.",
    description: "Els hyperscalers invertiran 600.000 milions de dòlars en infraestructura IA el 2026. Les empreses d'emmagatzematge, refrigeració, energia i xips —els 'pics i pales' moderns— són les grans beneficiades d'aquesta febre inversora.",
    image: "/picks-shovels-ai.jpg",
    imageAlt: "Infraestructura d'IA i centres de dades"
  },
  {
    id: "recuperacio-borsa-ia",
    slug: "la-recuperacio-de-la-borsa-i-la-pregunta-sobre-la-ia",
    title: "La recuperació de la borsa i la pregunta sobre la IA que ningú vol respondre",
    category: "Mercats / IA",
    date: "7 feb 2026",
    excerpt: "La borsa torna a pujar, però la mentalitat de 'comprar la baixada' amaga una pregunta incòmoda: pot una economia créixer sense el mercat laboral?",
    description: "La borsa es recupera impulsada per la mentalitat de comprar la baixada, però el mercat laboral mostra problemes seriosos. Si la IA compleix les seves promeses, l'economia podria créixer a través de la intensitat de capital en lloc de la participació laboral, plantejant una qüestió fonamental sobre el contracte social.",
    image: "/stock-market-recovery.jpg",
    imageAlt: "Recuperació de la borsa"
  },
];

// Parseja una data en format "5 feb 2026" i retorna un Date
function parseBlogDate(dateStr: string): Date {
  const months: Record<string, number> = {
    gen: 0, feb: 1, mar: 2, abr: 3, mai: 4, jun: 5,
    jul: 6, ago: 7, set: 8, oct: 9, nov: 10, des: 11
  };
  const [day, month, year] = dateStr.split(' ');
  return new Date(parseInt(year), months[month.toLowerCase()], parseInt(day));
}

// Retorna true si l'article té menys de 2 dies
export function isNewPost(dateStr: string): boolean {
  const postDate = parseBlogDate(dateStr);
  const now = new Date();
  const diffMs = now.getTime() - postDate.getTime();
  const diffDays = diffMs / (1000 * 60 * 60 * 24);
  return diffDays < 2;
}

export type BlogPost = typeof blogPosts[0];
